// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --green: #7ED321;
  --green-dark: #5AB015;
  --blue: #2C3E50;
  --bg: #F5F8FB;
  --bg-light: #ffffff;
  --text-dark: #0f172a;
  --text-muted: #475569;
  --border: #e5e7eb;
}

:root {
  --green: #7ED321;
  --green-dark: #5AB015;
  --blue: #2C3E50;
  --bg: #ffffff;
  --bg-light: #f8fafc;
  --text-dark: #0f172a;
  --text-muted: #475569;
  --border: #e5e7eb;
}

/* RESET */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background: var(--bg);
  color: var(--text-dark);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
}

h1, h2, h3, h4, h5, h6 {
  color: var(--text-dark);
  line-height: 1.3;
  margin-bottom: 1rem;
  font-weight: 700;
}

/* LAYOUT */
.about-root {
  position: relative;
  overflow: visible;
  background: var(--bg);
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.about-root > *:not(.bg) {
  position: relative;
  z-index: 2;
}

.about-wrap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
  overflow: visible;
}

/* BACKGROUND */
.bg {
  z-index: 0 !important;
  position: fixed;
  inset: 0;
  background: #ffffff;
}

/* SECTIONS */
.about-hero,
.about-values,
.about-story,
.leadership,
.about-cta,
.about-close {
  position: relative;
  padding: 100px 0;
  overflow: visible;
  z-index: 1;
}

/* HERO */
.about-hero {
  min-height: 50vh;
  display: flex;
  align-items: center;
  position: relative;
  background: #ffffff;
  padding: 120px 0 90px;
  margin-top: 30px;
  margin-bottom: 0;
  z-index: 1;
}

.eyebrow {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: var(--green);
  text-transform: uppercase;
}

.about-hero h1 {
  font-size: clamp(42px, 5vw, 58px);
  font-weight: 800;
  line-height: 1.2;
  margin: 16px 0 24px;
  letter-spacing: -0.02em;
  color: var(--blue);
  max-width: 800px;
}

.highlight {
  background: linear-gradient(135deg, var(--green), var(--green-dark));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.about-hero p {
  max-width: 820px;
  font-size: 17px;
  color: var(--text-muted);
  margin-bottom: 16px;
}

/* VALUES */
.about-values {
  padding: 100px 0 80px;
  background: #fff;
  position: relative;
  margin-top: -50px;
  z-index: 2;
}

.about-values::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(to bottom, #f8fafc, #ffffff);
  z-index: -1;
}

.about-values .about-wrap {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}

.about-values h2 {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--blue);
  margin-bottom: 16px;
  position: relative;
  display: inline-block;
}

.about-values h2:after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -12px;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, var(--green), var(--green-dark));
  border-radius: 2px;
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--text-muted);
  max-width: 700px;
  margin: 0 auto 60px;
  line-height: 1.6;
  font-weight: 400;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin: 0 auto;
  max-width: 1200px;
}

.value-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.value-card:hover {
  transform: translate3d(0, -5px, 0);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);
  z-index: 2;
}

.value-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--green), var(--green-dark));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  color: white;
}

.value-icon svg {
  width: 24px;
  height: 24px;
}

.value-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--blue);
  margin-bottom: 12px;
  line-height: 1.3;
}

.value-card p {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.7;
  margin: 0;
}

@media (max-width: 768px) {
  .about-values {
    padding: 40px 0 60px;
    margin-top: 0;
  }
  
  .about-values h2 {
    font-size: 2rem;
    margin-bottom: 12px;
  }
  
  .section-subtitle {
    font-size: 1rem;
    margin-bottom: 40px;
  }
  
  .values-grid {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 15px;
  }
  
  .value-card {
    padding: 24px;
  }
}

/* STORY */
.about-story {
  background: linear-gradient(to bottom, #f8fafc, #f1f5f9);
  padding: 120px 0 100px;
  position: relative;
  overflow: hidden;
}

.about-story::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(to bottom, transparent, #ffffff);
  z-index: 1;
}

.story-wrap {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}

.story-wrap h2 {
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: var(--blue);
}

.story-wrap p {
  font-size: 1.1rem;
  color: var(--text-muted);
  max-width: 800px;
  margin: 0 auto 3rem;
  line-height: 1.7;
}

.story-wrap h2 {
  font-size: 36px;
  font-weight: 800;
  margin-bottom: 24px;
}

.story-wrap p {
  max-width: 900px;
  font-size: 17px;
  color: var(--text-muted);
}

.principles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 64px;
}

.principle {
  border-top: 2px solid var(--border);
  padding-top: 20px;
  transform: translateZ(0);
  backface-visibility: hidden;
  will-change: transform;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.principle h4 {
  font-size: 17px;
  font-weight: 700;
  margin-bottom: 6px;
}

.principle p {
  font-size: 15px;
}

/* LEADERSHIP */
.leadership {
  padding: 100px 20px;
  background: var(--bg-light);
}

.leaders {
  max-width: 1100px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.leadership h2 {
  text-align: center;
  font-size: 40px;
  font-weight: 800;
  margin-bottom: 80px;
}

.leadership .section-subtitle {
  text-align: center;
}

.leaders {
  max-width: 1100px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 48px;
}

.leader {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.03);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateZ(0);
  will-change: transform;
  backface-visibility: hidden;
  overflow: visible !important;
}

.leader:hover {
  transform: translate3d(0, -5px, 0);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  z-index: 3;
}

.leader-head {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.leader-avatar {
  width: 72px;
  height: 72px;
  border-radius: 18px;
  background: linear-gradient(135deg, var(--green), var(--green-dark));
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: white;
  font-size: 1.5rem;
}

.leader-name {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--blue);
  margin-bottom: 0.25rem;
}

.leader-role {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--green);
  margin: 0;
}

.leader p {
  font-size: 15px;
  color: var(--text-muted);
}

/* CLOSING */
.about-close {
  background: #fff;
  padding: 100px 20px;
  text-align: center;
}

.about-close p {
  max-width: 800px;
  margin: 0 auto;
  font-size: 1.25rem;
  line-height: 1.7;
  color: var(--text-muted);
  font-weight: 500;
}

.about-close p {
  max-width: 900px;
  margin: auto;
  font-size: 20px;
  font-weight: 500;
}

/* RESPONSIVE */
@media (max-width: 1024px) {
  .about-wrap {
    padding: 0 1.5rem;
  }

  .about-hero {
    padding: 100px 0 80px;
  }

  .about-hero h1 {
    font-size: clamp(36px, 4.5vw, 48px);
  }

  .principles {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 32px;
  }

  .leaders {
    gap: 32px;
  }
}

@media (max-width: 768px) {
  .about-wrap {
    padding: 0 1.25rem;
  }

  .about-hero {
    padding: 80px 0 60px;
    min-height: auto;
  }
  
  .about-hero h1 {
    font-size: 2.25rem;
  }

  .about-hero p {
    font-size: 16px;
  }

  .cta-buttons {
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }
  
  .about-values h2,
  .story-wrap h2,
  .leadership h2 {
    font-size: 2rem;
  }

  .about-values,
  .about-story,
  .leadership,
  .about-cta,
  .about-close {
    padding: 60px 0;
  }
  
  .values-grid,
  .principles,
  .leaders {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .value-card,
  .leader {
    padding: 24px;
  }
  
  .leader-head {
    flex-direction: row;
    align-items: center;
  }
  
  .leader-avatar {
    flex-shrink: 0;
  }
  
  .about-close p {
    font-size: 1.1rem;
  }

  .principle-icon {
    font-size: 2rem;
    margin-bottom: 12px;
  }
}

@media (max-width: 480px) {
  .about-wrap {
    padding: 0 1rem;
  }

  .about-hero {
    padding: 100px 0 50px;
  }

  .eyebrow {
    font-size: 12px;
  }

  .about-hero h1 {
    font-size: 1.875rem;
    margin: 12px 0 20px;
  }

  .about-hero p {
    font-size: 15px;
  }

  .about-values,
  .about-story,
  .leadership,
  .about-cta,
  .about-close {
    padding: 50px 0;
  }

  .about-values h2,
  .story-wrap h2,
  .leadership h2 {
    font-size: 1.75rem;
  }

  .section-subtitle {
    font-size: 0.95rem;
  }

  .value-card,
  .leader {
    padding: 20px;
  }

  .value-card h3,
  .leader-name {
    font-size: 1.125rem;
  }

  .value-card p,
  .leader p {
    font-size: 0.875rem;
  }

  .value-icon {
    width: 40px;
    height: 40px;
  }

  .leader-head {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .leader-avatar {
    width: 60px;
    height: 60px;
    font-size: 1.25rem;
  }

  .principle {
    padding-top: 16px;
  }

  .principle h4 {
    font-size: 16px;
  }

  .principle p {
    font-size: 14px;
  }

  .about-close p {
    font-size: 1rem;
  }

  .cta-content h2 {
    font-size: 1.75rem;
  }

  .cta-content p {
    font-size: 15px;
  }
}

/* Animation */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fade-in {
  animation: fadeIn 0.6s ease-out forwards;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AboutUs.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kHAAkH;EAClH,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA,aAAa;AACb;;;;;;EAME,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,wDAAwD;EACxD,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mEAAmE;EACnE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,iDAAiD;EACjD,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oEAAoE;EACpE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,UAAU;AACV;EACE,wDAAwD;EACxD,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,4DAA4D;EAC5D,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,iDAAiD;EACjD,wBAAwB;EACxB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oEAAoE;EACpE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;;;;IAKE,eAAe;EACjB;;EAEA;;;IAGE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,eAAe;EACjB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,cAAc;AACd;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[":root {\n  --green: #7ED321;\n  --green-dark: #5AB015;\n  --blue: #2C3E50;\n  --bg: #F5F8FB;\n  --bg-light: #ffffff;\n  --text-dark: #0f172a;\n  --text-muted: #475569;\n  --border: #e5e7eb;\n}\n\n:root {\n  --green: #7ED321;\n  --green-dark: #5AB015;\n  --blue: #2C3E50;\n  --bg: #ffffff;\n  --bg-light: #f8fafc;\n  --text-dark: #0f172a;\n  --text-muted: #475569;\n  --border: #e5e7eb;\n}\n\n/* RESET */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n  background: var(--bg);\n  color: var(--text-dark);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: var(--text-dark);\n  line-height: 1.3;\n  margin-bottom: 1rem;\n  font-weight: 700;\n}\n\n/* LAYOUT */\n.about-root {\n  position: relative;\n  overflow: visible;\n  background: var(--bg);\n  z-index: 1;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.about-root > *:not(.bg) {\n  position: relative;\n  z-index: 2;\n}\n\n.about-wrap {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n  position: relative;\n  z-index: 2;\n  overflow: visible;\n}\n\n/* BACKGROUND */\n.bg {\n  z-index: 0 !important;\n  position: fixed;\n  inset: 0;\n  background: #ffffff;\n}\n\n/* SECTIONS */\n.about-hero,\n.about-values,\n.about-story,\n.leadership,\n.about-cta,\n.about-close {\n  position: relative;\n  padding: 100px 0;\n  overflow: visible;\n  z-index: 1;\n}\n\n/* HERO */\n.about-hero {\n  min-height: 50vh;\n  display: flex;\n  align-items: center;\n  position: relative;\n  background: #ffffff;\n  padding: 120px 0 90px;\n  margin-top: 30px;\n  margin-bottom: 0;\n  z-index: 1;\n}\n\n.eyebrow {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  color: var(--green);\n  text-transform: uppercase;\n}\n\n.about-hero h1 {\n  font-size: clamp(42px, 5vw, 58px);\n  font-weight: 800;\n  line-height: 1.2;\n  margin: 16px 0 24px;\n  letter-spacing: -0.02em;\n  color: var(--blue);\n  max-width: 800px;\n}\n\n.highlight {\n  background: linear-gradient(135deg, var(--green), var(--green-dark));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.about-hero p {\n  max-width: 820px;\n  font-size: 17px;\n  color: var(--text-muted);\n  margin-bottom: 16px;\n}\n\n/* VALUES */\n.about-values {\n  padding: 100px 0 80px;\n  background: #fff;\n  position: relative;\n  margin-top: -50px;\n  z-index: 2;\n}\n\n.about-values::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100px;\n  background: linear-gradient(to bottom, #f8fafc, #ffffff);\n  z-index: -1;\n}\n\n.about-values .about-wrap {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 20px;\n  text-align: center;\n}\n\n.about-values h2 {\n  font-size: 2.5rem;\n  font-weight: 800;\n  color: var(--blue);\n  margin-bottom: 16px;\n  position: relative;\n  display: inline-block;\n}\n\n.about-values h2:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: -12px;\n  transform: translateX(-50%);\n  width: 80px;\n  height: 4px;\n  background: linear-gradient(90deg, var(--green), var(--green-dark));\n  border-radius: 2px;\n}\n\n.section-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  max-width: 700px;\n  margin: 0 auto 60px;\n  line-height: 1.6;\n  font-weight: 400;\n}\n\n.values-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n  margin: 0 auto;\n  max-width: 1200px;\n}\n\n.value-card {\n  background: #ffffff;\n  border-radius: 12px;\n  padding: 32px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  z-index: 1;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  text-align: left;\n  border: 1px solid rgba(0, 0, 0, 0.03);\n}\n\n.value-card:hover {\n  transform: translate3d(0, -5px, 0);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08);\n  z-index: 2;\n}\n\n.value-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--green), var(--green-dark));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n  color: white;\n}\n\n.value-icon svg {\n  width: 24px;\n  height: 24px;\n}\n\n.value-card h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--blue);\n  margin-bottom: 12px;\n  line-height: 1.3;\n}\n\n.value-card p {\n  font-size: 0.95rem;\n  color: var(--text-muted);\n  line-height: 1.7;\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .about-values {\n    padding: 40px 0 60px;\n    margin-top: 0;\n  }\n  \n  .about-values h2 {\n    font-size: 2rem;\n    margin-bottom: 12px;\n  }\n  \n  .section-subtitle {\n    font-size: 1rem;\n    margin-bottom: 40px;\n  }\n  \n  .values-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    padding: 0 15px;\n  }\n  \n  .value-card {\n    padding: 24px;\n  }\n}\n\n/* STORY */\n.about-story {\n  background: linear-gradient(to bottom, #f8fafc, #f1f5f9);\n  padding: 120px 0 100px;\n  position: relative;\n  overflow: hidden;\n}\n\n.about-story::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 100px;\n  background: linear-gradient(to bottom, transparent, #ffffff);\n  z-index: 1;\n}\n\n.story-wrap {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 20px;\n  text-align: center;\n}\n\n.story-wrap h2 {\n  font-size: 2.5rem;\n  margin-bottom: 1.5rem;\n  color: var(--blue);\n}\n\n.story-wrap p {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  max-width: 800px;\n  margin: 0 auto 3rem;\n  line-height: 1.7;\n}\n\n.story-wrap h2 {\n  font-size: 36px;\n  font-weight: 800;\n  margin-bottom: 24px;\n}\n\n.story-wrap p {\n  max-width: 900px;\n  font-size: 17px;\n  color: var(--text-muted);\n}\n\n.principles {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n  margin-top: 64px;\n}\n\n.principle {\n  border-top: 2px solid var(--border);\n  padding-top: 20px;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n  will-change: transform;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.principle h4 {\n  font-size: 17px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n\n.principle p {\n  font-size: 15px;\n}\n\n/* LEADERSHIP */\n.leadership {\n  padding: 100px 20px;\n  background: var(--bg-light);\n}\n\n.leaders {\n  max-width: 1100px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n}\n\n.leadership h2 {\n  text-align: center;\n  font-size: 40px;\n  font-weight: 800;\n  margin-bottom: 80px;\n}\n\n.leadership .section-subtitle {\n  text-align: center;\n}\n\n.leaders {\n  max-width: 1100px;\n  margin: auto;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 48px;\n}\n\n.leader {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 32px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.03);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translateZ(0);\n  will-change: transform;\n  backface-visibility: hidden;\n  overflow: visible !important;\n}\n\n.leader:hover {\n  transform: translate3d(0, -5px, 0);\n  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);\n  z-index: 3;\n}\n\n.leader-head {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.leader-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 18px;\n  background: linear-gradient(135deg, var(--green), var(--green-dark));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  color: white;\n  font-size: 1.5rem;\n}\n\n.leader-name {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--blue);\n  margin-bottom: 0.25rem;\n}\n\n.leader-role {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--green);\n  margin: 0;\n}\n\n.leader p {\n  font-size: 15px;\n  color: var(--text-muted);\n}\n\n/* CLOSING */\n.about-close {\n  background: #fff;\n  padding: 100px 20px;\n  text-align: center;\n}\n\n.about-close p {\n  max-width: 800px;\n  margin: 0 auto;\n  font-size: 1.25rem;\n  line-height: 1.7;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.about-close p {\n  max-width: 900px;\n  margin: auto;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n/* RESPONSIVE */\n@media (max-width: 1024px) {\n  .about-wrap {\n    padding: 0 1.5rem;\n  }\n\n  .about-hero {\n    padding: 100px 0 80px;\n  }\n\n  .about-hero h1 {\n    font-size: clamp(36px, 4.5vw, 48px);\n  }\n\n  .principles {\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n    gap: 32px;\n  }\n\n  .leaders {\n    gap: 32px;\n  }\n}\n\n@media (max-width: 768px) {\n  .about-wrap {\n    padding: 0 1.25rem;\n  }\n\n  .about-hero {\n    padding: 80px 0 60px;\n    min-height: auto;\n  }\n  \n  .about-hero h1 {\n    font-size: 2.25rem;\n  }\n\n  .about-hero p {\n    font-size: 16px;\n  }\n\n  .cta-buttons {\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n  }\n\n  .btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .about-values h2,\n  .story-wrap h2,\n  .leadership h2 {\n    font-size: 2rem;\n  }\n\n  .about-values,\n  .about-story,\n  .leadership,\n  .about-cta,\n  .about-close {\n    padding: 60px 0;\n  }\n  \n  .values-grid,\n  .principles,\n  .leaders {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .value-card,\n  .leader {\n    padding: 24px;\n  }\n  \n  .leader-head {\n    flex-direction: row;\n    align-items: center;\n  }\n  \n  .leader-avatar {\n    flex-shrink: 0;\n  }\n  \n  .about-close p {\n    font-size: 1.1rem;\n  }\n\n  .principle-icon {\n    font-size: 2rem;\n    margin-bottom: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-wrap {\n    padding: 0 1rem;\n  }\n\n  .about-hero {\n    padding: 100px 0 50px;\n  }\n\n  .eyebrow {\n    font-size: 12px;\n  }\n\n  .about-hero h1 {\n    font-size: 1.875rem;\n    margin: 12px 0 20px;\n  }\n\n  .about-hero p {\n    font-size: 15px;\n  }\n\n  .about-values,\n  .about-story,\n  .leadership,\n  .about-cta,\n  .about-close {\n    padding: 50px 0;\n  }\n\n  .about-values h2,\n  .story-wrap h2,\n  .leadership h2 {\n    font-size: 1.75rem;\n  }\n\n  .section-subtitle {\n    font-size: 0.95rem;\n  }\n\n  .value-card,\n  .leader {\n    padding: 20px;\n  }\n\n  .value-card h3,\n  .leader-name {\n    font-size: 1.125rem;\n  }\n\n  .value-card p,\n  .leader p {\n    font-size: 0.875rem;\n  }\n\n  .value-icon {\n    width: 40px;\n    height: 40px;\n  }\n\n  .leader-head {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .leader-avatar {\n    width: 60px;\n    height: 60px;\n    font-size: 1.25rem;\n  }\n\n  .principle {\n    padding-top: 16px;\n  }\n\n  .principle h4 {\n    font-size: 16px;\n  }\n\n  .principle p {\n    font-size: 14px;\n  }\n\n  .about-close p {\n    font-size: 1rem;\n  }\n\n  .cta-content h2 {\n    font-size: 1.75rem;\n  }\n\n  .cta-content p {\n    font-size: 15px;\n  }\n}\n\n/* Animation */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.6s ease-out forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
